import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FormGenerator } from "../helper/FormGenerator";
import { toast } from "react-toastify";
import axios, { all } from "axios";
import { API_URL } from "../constants";
import { xorEncrypt } from "../utils/xorCrypto";
import { useSiteData } from "../hooks/provider/SiteDataProvider";
import { countryOptions, stateOptions } from "../utils/appUtils";

const RegisterForm = () => {
  const { siteData } = useSiteData();
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formPayload = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (key === 'password' && value) {
        formPayload.append('password', xorEncrypt(value));
      } else if (key === 'confirm_password' && value) {
        formPayload.append('confirm_password', xorEncrypt(value));
      } else if (value !== undefined && value !== null) {
        formPayload.append(key, value);
      }
    });

    try {
      const registerToastId = toast.loading("Submitting your registration...");
      const registerResponse = await axios.post(`${API_URL}/vendor/register`, formPayload, {
        headers: { "Content-Type": "application/json" },
      });

      toast.update(registerToastId, {
        render: "Registration successful!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });

      setLoading(true);
      const loginToastId = toast.loading('Logging in...', { autoClose: false });

      try {
        const encPass = xorEncrypt(formData.password);
        const loginResponse = await axios.post(`${API_URL}/vendor/login`, {
          email: formData.email,
          password: encPass,
        });

        if (loginResponse.data.temp_token && loginResponse.data.user) {
          localStorage.setItem('vendorProfile', JSON.stringify(loginResponse.data.user));
          toast.update(loginToastId, {
            render: 'Temporary token received. Please complete your profile.',
            type: 'info',
            isLoading: false,
            autoClose: 3000,
          });
          navigate('/vendor/complete-profile');
          return;
        }
      } catch (err) {
        toast.update(loginToastId, {
          render: err.response?.data?.message || 'Login failed! Please try again.',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        });
      } finally {
        setLoading(false);
      }

      setFormData({});

    } catch (error) {
      toast.dismiss();
      const errorMessage = error.response?.data?.message || 'Something went wrong. Please try again.';
      toast.error(errorMessage);
    }
  };

  return (
    siteData.new_vendor_regsitartion == 1 ?
      <>
        <h4 className="text-start fw-bold mb-5" style={{ color: "hsl(217, 10%, 50.8%)" }}>
          Store Registration Form
        </h4>

        <form className="mpforms" onSubmit={handleSubmit}>
          <div className="row">
            <FormGenerator
              fields={[
                { id: 'first_name', label: 'Owner First Name', type: 'text', maxLength: 100, class: 'col-md-6', required: true },
                { id: 'last_name', label: 'Owner Last Name', type: 'text', maxLength: 100, class: 'col-md-6', required: true },

                { id: 'store_name', label: 'Store Display Name', type: 'text', maxLength: 100, class: 'col-md-6', required: true },
                { id: 'store_legal_name', label: 'Store Legal Name', type: 'text', maxLength: 100, class: 'col-md-6', required: true },

                { id: 'phone', label: 'Phone Number', type: 'tel', class: 'col-md-6', required: true, prefix: '+91', minLength: 10, maxLength: 10, isNumeric: true },
                { id: 'email', label: 'Email', type: 'email', class: 'col-md-6', maxLength: 100, required: true },
                {
                  id: "password",
                  label: "Password",
                  type: "password",
                  minLength: 8,
                  maxLength: 20,
                  class: "col-md-6",
                  required: true,
                  isAlphaNumericWithSymbols: true,
                  hint:
                    "Password must be at least 8 characters long and contain both letters and numbers.",
                },
                {
                  id: "confirm_password",
                  label: "Confirm Password",
                  type: "password",
                  matchWith: "password",
                  class: "col-md-6",
                  required: true,
                },
                { id: 'address', label: 'Address', type: 'textarea', class: 'col-md-12', required: true },
                { id: 'city', label: 'City', type: 'text', class: 'col-md-6', maxLength: 100, required: true },
                { id: 'zip', label: 'PIN Code', type: 'text', class: 'col-md-6', minLength: 6, maxLength: 6, isNumeric: true, required: true, allowSpace: false, },
                { id: 'state', label: 'State', type: 'select', options: stateOptions, searchable: true, class: 'col-md-6', required: true },
                { id: 'country', label: 'Country', type: 'select', options: countryOptions, class: 'col-md-6', required: true },
                { id: 'gst', label: 'GSTIN Number', type: 'text', class: 'col-md-6', required: true, minLength: 15, maxLength: 15, isAlphaNumeric: true, },
                { id: 'fssai_number', label: 'FSSAI Number', type: 'text', class: 'col-md-6', required: true, minLength: 14, maxLength: 14, isAlphaNumeric: true, },
              ]}
              fieldData={formData}
              onChange={(field, value) => setFormData(prev => ({ ...prev, [field]: value }))}
              onSubmit={false}
              hTure={false}
            />

            <div className="col-md-12">
              <button type="submit" className="btn btn-primary w-100">
                Submit
              </button>
            </div>

            <div className="col-md-12 text-center py-2">
              <span>
                Existing User? <a href="/vendor/login">Login</a>
              </span>
            </div>
          </div>
        </form>
      </>
      :
      <div className="alert alert-warning text-center mt-4" role="alert">{siteData.new_vendor_regsitartion}
        <h4 className="alert-heading">New Vendor Registration is Currently Disabled</h4>
        <p>We're not accepting new vendor sign-ups at the moment. Please stay tuned — exciting updates are on the way!</p>
      </div>
  );
};

export default RegisterForm;
